module.exports = __webpack_public_path__ + "img/min_pickup.743816d3.svg";